import { Component, ElementRef, OnInit } from '@angular/core';
import { AgreementsService } from './agreements.service';
import { hiddenElementSlideInOut } from '../../utils/animations/slides.animation';
import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: 'agreements-component',
  templateUrl: './agreements.component.html',
  animations: [hiddenElementSlideInOut],
})
export class AgreementsComponent implements OnInit {

  consentForm: any;
  isLoading = true;
  hideAgreementsSection = true;

  constructor(
    private el: ElementRef,
    public agreementsService: AgreementsService,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.consentForm = await this.agreementsService.initializeAgreements();
      this.hideAgreementsSection = !this.consentArray?.length;
    } catch (error) {
      console.error('Error initializing agreements:', error);
    }
    finally {
      this.isLoading = false;
    }
  }

  get consentArray(): FormArray {
    return this.consentForm.get('consentArray') as FormArray;
  }

  public accordionScroll(data: HTMLAnchorElement): void {
    const id = data.getAttribute('id');
    const element = this.el.nativeElement.querySelector(`#${id}`);

    if (element) {
      const itemOffset = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: itemOffset - 70,
        behavior: 'smooth'
      });

      const stopScrollOnWheel = (): void => {
        window.scrollTo(0, window.scrollY);
        window.removeEventListener('wheel', stopScrollOnWheel);
      };

      window.addEventListener('wheel', stopScrollOnWheel);
    }
  }

  public onAllConsentChange(checked: boolean): void {
    const consentArray = this.consentForm.get('consentArray') as FormArray;

    consentArray.controls.forEach((control, groupIndex) => {
      control.get('selected')?.setValue(checked, { emitEvent: false });
      control.get('selected')?.markAsTouched();
      control.get('selected')?.updateValueAndValidity();

      this.onCheckboxChange(groupIndex, checked, false);
    });

    this.agreementsService.sendSelectionList(this.extractSelectedAgreements());
  }

  public onCheckboxChange(groupIndex: number, value: boolean, shouldSendSelectionList: boolean = true, agreementIndex?: number): void {
    const consentArray = this.consentForm.get('consentArray') as FormArray;
    const consentGroup = consentArray.at(groupIndex) as FormGroup;
    const playAgreementsArray = consentGroup.get('playAgreements') as FormArray;

    if (agreementIndex !== undefined) {
      const agreementControl = playAgreementsArray.at(agreementIndex) as FormGroup;
      agreementControl.get('selected')?.setValue(value, { emitEvent: false });
      agreementControl.get('selected')?.markAsTouched();
      agreementControl.get('selected')?.updateValueAndValidity();
    } else {
      playAgreementsArray.controls.forEach((agreementControl: AbstractControl) => {
        agreementControl.get('selected')?.setValue(value, { emitEvent: false });
        agreementControl.get('selected')?.markAsTouched();
        agreementControl.get('selected')?.updateValueAndValidity();
      });
    }

    const allSelected = playAgreementsArray.controls.every(
      (ctrl: AbstractControl) => ctrl.get('selected')?.value === true
    );

    const groupSelectedControl = consentGroup.get('selected') as FormControl;
    groupSelectedControl.setValue(allSelected, { emitEvent: false });

    if (allSelected || !allSelected) {
      groupSelectedControl.markAsTouched();
      groupSelectedControl.updateValueAndValidity();
    } else {
      groupSelectedControl.markAsUntouched();
    }

    if (shouldSendSelectionList) {
      this.agreementsService.sendSelectionList(this.extractSelectedAgreements());
    }
  }

  protected extractSelectedAgreements(): Array<string> {
    let selectedElements: Array<string> = [];

    const consentArray = this.consentForm.get('consentArray') as FormArray;

    consentArray.controls.forEach((control, groupIndex) => {
      const playAgreementsArray = control.get('playAgreements') as FormArray;

      playAgreementsArray.controls.forEach((agreementControl, agreementIndex) => {
        if (agreementControl.get('selected')?.value) {
          const omsCode = agreementControl.get('omsCode')?.value;

          if (omsCode) {
            selectedElements.push(omsCode);
          }
        }
      });
    });

    return selectedElements;
  }
}
